import React from 'react';
import { gql } from 'apollo-boost';
import { useSubscription } from '@apollo/react-hooks';
import { Logger } from 'services/logging';
import { toast } from 'react-toastify';
import { Toast } from 'components/shared';
import { useTranslation } from 'hooks';

export const NODE_UPDATED_SUBSCRIPTION = gql`
  subscription nodeUpdatedSubscription($nodeId: String!) {
    nodeUpdated(nodeId: $nodeId) {
      eventType
      node {
        id
        title
        pins
      }
    }
  }
`;

interface NodeSubsciptionProps {
  nodeId: string;
  nodeTitle: string;
  groupId?: string;
}

export const NodeSubscription = ({ nodeId, nodeTitle, groupId }: NodeSubsciptionProps) => {
  const { t } = useTranslation();

  const { data: subscriptionData } = useSubscription(NODE_UPDATED_SUBSCRIPTION, {
    variables: {
      nodeId: nodeId,
    },
  });

  /**
   * Subscription response
   * While in group screen, show toast notification
   */
  if (subscriptionData && subscriptionData?.eventType === 'Pinned' && groupId) {
    Logger.log(subscriptionData);
    const result = subscriptionData?.node?.pins?.includes(groupId) ? 'pinned' : 'unpinned';
    toast(
      <Toast
        message={t('subscriptions.node-pinned', { nodeTitle: nodeTitle, result: result })}
        hasCloseButton
      />,
      {
        position: toast.POSITION.BOTTOM_LEFT,
        hideProgressBar: true,
        closeButton: false,
        closeOnClick: true,
        autoClose: 5000,
      }
    );
  }

  return <></>;
};
